const BudgetStatusEnum = {
  SAVED: 'SAVED',
  BUDGET_SENDED: 'BUDGET_SENDED',
  BUDGET_ANSWERED: 'BUDGET_ANSWERED',
  BUDGET_APPROVED: 'BUDGET_APPROVED',
  BUDGET_CANCELED: 'BUDGET_CANCELED',
}
Object.freeze(BudgetStatusEnum)
export { BudgetStatusEnum }
